import { auth0 } from 'src/auth0.js';
import { createApp } from 'vue';
import App from './App.vue';
import 'mdb-vue-ui-kit/css/mdb.min.css';
import router from "./router";
import * as Sentry from "@sentry/vue";

const app = createApp(App);

Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN
});

app
  .use(router)
  .use(auth0);

app.mount('#app');
